import { render, staticRenderFns } from "./CartaoItens.vue?vue&type=template&id=cc9b442a&scoped=true"
import script from "./CartaoItens.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoItens.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoItens.vue?vue&type=style&index=0&id=cc9b442a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc9b442a",
  null
  
)

export default component.exports